import styled from 'styled-components';

import { flexEnd } from '../../../style/reusableStyle';

export const CreateJobsContainerStyled = styled.div`
  margin: 18px 0px 200px;
  max-width: 600px;

  & .heading,
  & .selection-notes {
    margin-bottom: 30px;
  }

  & .upload-logo-svg {
    margin: 10px 0px;
  }

  & .browse-files {
    margin-bottom: 30px;
  }
`;

export const CreateTechnicianJobsContainerStyled = styled.div``;
export const CreatePrinterJobsContainerStyled = styled.div``;
export const HireProfessionalStyled = styled.div`
  width: 100%;
  /* max-width: 1300px;
  margin: 0 auto; */
`;

export const AdditionalReqContainerStyled = styled.div<{
  $hasAdditional?: boolean;
}>`
  margin-bottom: 30px;

  padding: ${({ $hasAdditional }) => ($hasAdditional ? '15px 13px' : '0px')};
  & button {
    color: #fff;
    background: ${({ theme }) => theme.colors.disableText};
    border-color: ${({ theme }) => theme.colors.disableText};
  }
`;

export const CloseAdditionalWrapperStyled = styled.div`
  ${flexEnd(0)};

  & svg {
    cursor: pointer;
    path {
      stroke: red;
    }
  }
`;

export const SelectPDFAndQuantityContainerStyled = styled.div`
  margin-bottom: 40px;

  & .section-text {
    margin-bottom: 20px;
  }
`;

export const PDFWithQuantityContainerStyled = styled.div`
  & .individual-pdf-row {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 20px;

    @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
      flex-direction: column;
      gap: 6px;
    }
  }
`;
